<template>
    <div>
        <h3 class="page-title">作业</h3>
        <div class="toolbar">
            <el-button type="success" size="small" @click="taskFormVisible = true">添加作业</el-button>
        </div>
        <div class="filters">
            <el-form :inline="true" :model="params" ref="filterForm" class="demo-form-inline">
                <el-form-item prop="course_id" label="班级">
                    <el-select
                    size="small"
                      v-model="params.course_id"
                      filterable
                      remote
                      reserve-keyword
                      loading-text="加载中..."
                      no-match-text="无匹配数据"
                      no-data-text="无数据"
                      placeholder="输入班级名称"
                      :remote-method="searchCourse"
                      :loading="course_loading">
                      <el-option label="全部" value=""></el-option>
                      <el-option
                        v-for="item in courseList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="lesson_id" label="授课内容">
                    <el-select
                    size="small"
                    v-model="params.lesson_id"
                    filterable
                    remote
                    reserve-keyword
                    loading-text="加载中..."
                    no-match-text="无匹配数据"
                    no-data-text="无数据"
                    placeholder="输入授课内容标题"
                    :remote-method="searchLesson"
                    :loading="lesson_loading">
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in lessonList"
                      :key="item.id"
                      :label="item.subject"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" @click="search">查找</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" @click="clear">清除</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div>
            <el-table v-loading="loading" empty-text="无数据" :data="taskList" stripe style="width: 100%">
                <el-table-column prop="course_name" label="班级"></el-table-column>
                <el-table-column prop="lesson_subject" label="授课内容"></el-table-column>
                <el-table-column prop="name" label="作业"></el-table-column>
                <el-table-column label="完成情况" align="center">
                    <template slot-scope="scope">
                        {{scope.row.submitted_homeworks_count ? Math.round(scope.row.submitted_homeworks_count/ scope.row.homeworks_count  * 100) : '0'}}%
                    </template>
                </el-table-column>
                <el-table-column prop="" label="操作" width="155px" align="left">
                    <template slot-scope="scope">
                        <el-button type="warning" size="mini" plain @click="edit(scope.row)" icon="el-icon-edit"></el-button>
                        <el-button type="danger" size="mini" plain @click="remove(scope.row)" icon="el-icon-delete"></el-button>
                        <el-button type="primary" size="mini" plain @click="showHomeworks(scope.row.id)" icon="el-icon-view"></el-button>
                        <el-button type="primary" size="mini" plain @click="showPublishPanel(scope.row)" icon="fa fa-send"></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="params.page"
                :page-sizes="[20, 50, 100]"
                :page-size="params.per_page"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog title="添加作业" :visible.sync="taskFormVisible">
            <el-form :model="taskForm" ref="taskForm" :rules="rules" label-width="120px">
                <el-form-item prop="course_id" label="班级">
                    <el-select
                      v-model="course_id"
                      filterable
                      remote
                      reserve-keyword
                      loading-text="加载中..."
                      no-match-text="无匹配数据"
                      no-data-text="无数据"
                      placeholder="选择一个班级"
                      :remote-method="searchCourse"
                      :loading="course_loading">
                      <el-option
                        v-for="item in courseList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="lesson_id"  label="授课内容">
                  <el-select
                    v-model="taskForm.lesson_id"
                    filterable
                    remote
                    reserve-keyword
                    loading-text="加载中..."
                    no-match-text="无匹配数据"
                    no-data-text="无数据"
                    placeholder="选择授课标题"
                    :remote-method="searchLesson2"
                    :loading="lesson_loading">
                    <el-option
                      v-for="item in lessonList2"
                      :key="item.id"
                      :label="item.subject"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="name" label="作业">
                  <el-input v-model="taskForm.name"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取消</el-button>
                <el-button type="primary" @click="submitForm">确认</el-button>
            </div>
        </el-dialog>

        <el-dialog title="检查作业" :visible.sync="homeworksVisible">
            <el-table v-loading="homeworkLoading" empty-text="无数据" :data="homeworksList" stripe style="width: 100%">
              <el-table-column prop="student_name" label="学生"></el-table-column>
              <el-table-column prop="status" label="作业状态" align="center">
                <template slot-scope="scope">
                    <el-tag :type="tagsColor[scope.row.status]" size="mini">{{tagsTxt[scope.row.status]}}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="score" label="成绩" align="center">
                  <template slot-scope="scope">
                      <star :stars="getScore(scope.row.results)" :maxStar="3" readonly :star-size="18"></star>
                  </template>
              </el-table-column>
          </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="homeworksVisible = false">关闭</el-button>
            </div>
        </el-dialog>

        <el-dialog title="发布作业" :visible.sync="publishVisible">
            <div class="loading-box" v-loading="student_loading">
              <h3 class="panel-title">学生</h3>
              <el-checkbox v-if="studentsList.length > 3" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
              <el-checkbox-group class="student-checkbox-group" v-model="student" @change="handleCheckedStudentChange">
                  <el-checkbox class="student-checkbox" v-for="item in studentsList" :disabled="publishedMap[item.user_id]" :label="item.user_id" :key="item.user_id">{{item.user_name}}</el-checkbox>
              </el-checkbox-group>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="publishVisible = false">关闭</el-button>
                <el-button @click="publish">发布作业</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Star from '../../components/Star'

export default {
  components: { Star },
  data () {
    return {
      params: {
        datetime: '',
        teacher_name: '',
        lesson_id: '',
        course_id: '',
        page: 1,
        per_page: 20,
        order_by: [],
        fields: []
      },
      total: 0,
      taskList: [],
      lessonList: [],
      lessonList2: [],
      courseList: [],
      loading: false,
      course_loading: false,
      lesson_loading: false,
      taskFormVisible: false,
      course_id: '',
      taskForm: {
        id: '',
        lesson_id: '',
        name: ''
      },
      rules: {
        lesson_id: [{ required: true, message: '课程不能为空' }],
        name: [{ required: true, message: '名称不能为空' }]
      },
      homeworksVisible: false,
      homeworkLoading: false,
      homeworksList: [],
      tagsColor: {
        unread: 'warning',
        accepted: 'primary',
        done: 'success'
      },
      tagsTxt: {
        unread: '未开始',
        accepted: '进行中',
        done: '已完成'
      },

      _students: {}, // course cache
      publishVisible: false,
      isIndeterminate: false,
      checkAll: false,
      student_loading: false,
      studentsList: [],
      currTask: {},
      student: [],
      publishedMap: {}
    }
  },

  created () {
    this.getDataList()
    this.searchCourse()
    this.searchLesson()
  },
  watch: {
    course_id (value) {
      if (value) {
        this.searchLesson2()
      }
    },
    'params.course_id' (value) {
      if (value) {
        this.searchLesson()
      }
    }
  },
  methods: {
    handleCheckAllChange (val) {
      this.student = val ? this.studentsList.map(el => el.user_id) : []
      console.log(this.student)
      this.isIndeterminate = false
    },
    handleCheckedStudentChange (value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.studentsList.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.studentsList.length
    },
    publish () {
      if (this.student.length == 0) {
        this.$warning('选择一个学生')
        return
      }
      this.$api.tasks.start(this.currTask.id, this.student).then(data => {
        this.$success('Publish Success!')
        this.publishVisible = false
        // this.reset()
      }).catch(err => {
        this.publishVisible = false
        this.$error(err)
      })
    },
    showPublishPanel (task) {
      this.currTask = task
      this.isIndeterminate = false
      this.checkAll = false
      this.student = []
      this.publishedMap = {}
      // if(this._students[task.course_id]){
      //   this.studentsList = this._students[task.course_id]
      //   return
      // }
      this.student_loading = true
      this.$api.tasks
        .homeworks(task.id)
        .then(data => {
          let tmp = {}
          data.forEach(el => {
            tmp[el.student_id] = true
          })
          this.publishedMap = tmp
          this.$api.courses
            .students({ id: task.course_id, page: 1, per_page: 100 })
            .then(data => {
            // this.total = data.total;
            // this._students[task.course_id] = data.data
              this.studentsList = data.data
              this.student_loading = false
            })
            .catch(err => {
              this.student_loading = false
            })
        })
        .catch(err => {
          this.$error(err)
        })
      this.publishVisible = true
    },
    getScore (results) {
      if (results.length > 0) {
        let sum = results.reduce((sum, n) => {
          return { score: sum.score + n.score }
        }).score

        let ava = sum / results.length
        if (ava < 33.3) {
          return 1
        } else if (ava < 66.7) {
          return 2
        } else {
          return 3
        }
      }
      return 0
    },
    showHomeworks (taskid) {
      this.homeworksVisible = true
      this.homeworkLoading = true
      this.$api.tasks
        .homeworks(taskid)
        .then(data => {
          this.homeworksList = data
          this.homeworkLoading = false
        })
        .catch(err => {
          this.$error(err)
          this.homeworkLoading = false
        })
    },
    submitForm () {
      this.$refs['taskForm'].validate(valid => {
        if (valid) {
          if (!this.taskForm.id) {
            this.$api.tasks
              .create(this.taskForm)
              .then(data => {
                this.$success('作业创建成功')
                // this.$store.commit("tmp_task", this.taskForm);
                // this.$router.push("/homework/topic/form/"+ data.id);
                this.$store.commit('tmp_task', data)
                this.$router.push('/homework/task/form/' + data.id)
                this.cancel()
                this.getDataList()
              })
              .catch(err => this.$error(err))
          } else {
            this.$api.tasks
              .save(this.taskForm.id, this.taskForm)
              .then(data => {
                this.$success('作业保存成功')
                this.cancel()
                this.getDataList()
              })
              .catch(err => this.$error(err))
          }
        }
      })
    },
    searchCourse (name) {
      this.course_loading = true
      this.$api.courses
        .list({ fields: ['id', 'name'], page: 1, per_page: 100, name })
        .then(data => {
          this.courseList = data.data
          this.course_loading = false
        })
        .catch(err => {
          this.$error(err)
          this.course_loading = false
        })
    },
    searchLesson (subject) {
      this.lesson_loading = true
      if (this.params.course_id) {
        this.$api.courses
          .lessons({
            id: this.params.course_id || '',
            fields: ['id', 'subject'],
            page: 1,
            per_page: 100,
            subject
          })
          .then(data => {
            this.lessonList = data
            this.lesson_loading = false
          })
          .catch(err => {
            this.$error(err)
            this.lesson_loading = false
          })
      } else {
        this.$api.lessons
          .list({
            fields: ['id', 'subject'],
            page: 1,
            per_page: 100,
            subject
          })
          .then(data => {
            this.lessonList = data
            this.lesson_loading = false
          })
          .catch(err => {
            this.$error(err)
            this.lesson_loading = false
          })
      }
    },
    searchLesson2 (subject) {
      this.lesson_loading = true
      this.$api.courses
        .lessons({
          id: this.course_id,
          fields: ['id', 'subject'],
          page: 1,
          per_page: 100,
          subject
        })
        .then(data => {
          this.lessonList2 = data
          this.lesson_loading = false
        })
        .catch(err => {
          this.$error(err)
          this.lesson_loading = false
        })
    },
    getDataList () {
      this.loading = true
      this.$api.tasks
        .list(this.params)
        .then(data => {
          this.total = data.total
          this.taskList = data.data
          this.loading = false
        })
        .catch(err => {
          this.$error(err)
          this.loading = false
        })
    },
    handleCurrentChange (page) {
      this.params.page = page
      this.getDataList()
    },
    handleSizeChange (size) {
      this.params.per_page = size
      this.getDataList()
    },
    search () {
      this.getDataList()
    },
    clear () {
      this.$refs['filterForm'].resetFields()
      this.getDataList()
    },
    edit (target) {
      // this.taskFormVisible = true;
      // this.taskForm.id = target.id;
      // this.taskForm.lesson_id = target.lesson_id;
      // this.taskForm.name = target.name;
      this.$store.commit('tmp_task', target)
      this.$router.push('/homework/task/form/' + target.id)
    },
    remove (target) {
      this.$confirm(`你确认删除[${target.name}]?`, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        closeOnPressEscape: false
      })
        .then(() => {
          this.$api.tasks
            .delete(target.id)
            .then(data => {
              this.$success(`${target.name}已删除!`)
              this.getDataList()
            })
            .catch(err => {
              this.$error(err)
            })
        })
        .catch(() => {})
    },
    cancel () {
      this.taskFormVisible = false
      this.taskForm.id = ''
      this.taskForm.lesson_id = ''
      this.taskForm.name = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.student-checkbox-group{
  display: flex;
  flex-wrap: wrap;
  .student-checkbox{
    margin: 0;
    width: 33%;
  }
}
</style>
